import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('clienti');
export const actions = helper.createActions('clienti', actionTypes);